var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'truevalue-layout' : _vm.isTruevalue }},[_c('AdminHeader',{ref:"adminHeader"}),_vm._t("default"),(!_vm.$route.meta.hideFooter)?_c('MainFooter',{attrs:{"business":_vm.business}}):_vm._e(),_c('upgrade-modal'),_c('FreeUpgradeModal',{ref:"freeUpgrade"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }